import { render, staticRenderFns } from "./resultunit-unit.vue?vue&type=template&id=608971f6&scoped=true"
import script from "./resultunit-unit.vue?vue&type=script&lang=js"
export * from "./resultunit-unit.vue?vue&type=script&lang=js"
import style0 from "./resultunit-unit.vue?vue&type=style&index=0&id=608971f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608971f6",
  null
  
)

export default component.exports